// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Label = require("../../common/Components/Label.bs.js");
let Scalars = require("../../../scalars/Scalars.bs.js");
let Stdlib_Array = require("@rescript/runtime/lib/js/Stdlib_Array.js");
let PropertyPrice = require("../../common/Components/PropertyPrice.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let WizardFormUtils = require("../../common/Form/WizardFormUtils.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let DevelopmentUnitSearchResultCard = require("./DevelopmentUnitSearchResultCard.bs.js");
let DevelopmentUnitSearchResultAgent = require("./DevelopmentUnitSearchResultAgent.bs.js");
let DevelopmentUnitSearchResultActions = require("./DevelopmentUnitSearchResultActions.bs.js");
let DevelopmentUnitSearchResultTimestamp = require("./DevelopmentUnitSearchResultTimestamp.bs.js");
let DevelopmentUnitSearchResultAttributes = require("../../common/Components/DevelopmentUnitSearchResultAttributes.bs.js");
let DevelopmentUnitSearchResultTitleAndLocation = require("./DevelopmentUnitSearchResultTitleAndLocation.bs.js");
let DevelopmentUnitSearchResult_newDevelopmentSampleUnit_graphql = require("../../../__generated__/DevelopmentUnitSearchResult_newDevelopmentSampleUnit_graphql.bs.js");

function developmentSummaryText(developer, estimatedCompletion) {
  let values = Stdlib_Array.keepSome([
    WizardFormUtils.noneIfEmpty(developer),
    Stdlib_Option.map(estimatedCompletion, estimatedCompletion => "Est. delivery " + Scalars.Year.toString(estimatedCompletion))
  ]);
  if (values.length !== 0) {
    return values.join(" • ");
  }
}

function DevelopmentUnitSearchResult$StatusLabel(props) {
  return JsxRuntime.jsx(Label.Info.make, {
    text: "Sample Unit"
  });
}

let StatusLabel = {
  make: DevelopmentUnitSearchResult$StatusLabel
};

let convertFragment = DevelopmentUnitSearchResult_newDevelopmentSampleUnit_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, DevelopmentUnitSearchResult_newDevelopmentSampleUnit_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(DevelopmentUnitSearchResult_newDevelopmentSampleUnit_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, DevelopmentUnitSearchResult_newDevelopmentSampleUnit_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(DevelopmentUnitSearchResult_newDevelopmentSampleUnit_graphql.node, convertFragment, fRef);
}

let UnitFragment_developmentProjectUnitType_decode = DevelopmentUnitSearchResult_newDevelopmentSampleUnit_graphql.Utils.developmentProjectUnitType_decode;

let UnitFragment_developmentProjectUnitType_fromString = DevelopmentUnitSearchResult_newDevelopmentSampleUnit_graphql.Utils.developmentProjectUnitType_fromString;

let UnitFragment = {
  developmentProjectUnitType_decode: UnitFragment_developmentProjectUnitType_decode,
  developmentProjectUnitType_fromString: UnitFragment_developmentProjectUnitType_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function DevelopmentUnitSearchResult(props) {
  let unit = RescriptRelay_Fragment.useFragment(DevelopmentUnitSearchResult_newDevelopmentSampleUnit_graphql.node, convertFragment, props.unit);
  let summary = developmentSummaryText(unit.development.developer, unit.development.estimatedCompletion);
  let price = unit.price;
  return JsxRuntime.jsx(DevelopmentUnitSearchResultCard.make, {
    unit: unit.fragmentRefs,
    label: JsxRuntime.jsx(DevelopmentUnitSearchResult$StatusLabel, {}),
    children: JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx(DevelopmentUnitSearchResultTitleAndLocation.make, {
          unit: unit.fragmentRefs
        }),
        price !== undefined ? JsxRuntime.jsx(PropertyPrice.FromPropertyPrice.make, {
            propertyPrice: price.fragmentRefs,
            size: "medium"
          }) : JsxRuntime.jsx("div", {
            children: "No price set",
            className: "text-lg font-medium text-gray-500"
          }),
        JsxRuntime.jsx(DevelopmentUnitSearchResultAttributes.make, {
          unit: unit.fragmentRefs
        }),
        summary !== undefined ? JsxRuntime.jsx("div", {
            children: summary,
            className: "text-sm text-zinc-600"
          }) : null,
        JsxRuntime.jsx(DevelopmentUnitSearchResultAgent.make, {
          unit: unit.fragmentRefs
        }),
        JsxRuntime.jsx(DevelopmentUnitSearchResultTimestamp.make, {
          unit: unit.fragmentRefs
        }),
        JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(DevelopmentUnitSearchResultActions.make, {
            unit: unit.fragmentRefs
          }),
          className: "mt-auto"
        })
      ],
      className: "flex h-full flex-col gap-4"
    })
  });
}

let Card;

let TitleAndLocation;

let Agent;

let Timestamp;

let Actions;

let make = DevelopmentUnitSearchResult;

exports.developmentSummaryText = developmentSummaryText;
exports.StatusLabel = StatusLabel;
exports.UnitFragment = UnitFragment;
exports.Card = Card;
exports.TitleAndLocation = TitleAndLocation;
exports.Agent = Agent;
exports.Timestamp = Timestamp;
exports.Actions = Actions;
exports.make = make;
/* Label Not a pure module */
